export const replaceslashwithquote = /\\(["'])/g ;